function wareki (year) {
    var eras = [
        { year: 2018, name: '令和' },
        { year: 1988, name: '平成' },
        { year: 1925, name: '昭和' },
        { year: 1911, name: '大正' },
        { year: 1867, name: '明治' }
    ]

    for (var i in eras) {
        var era = eras[i]
        var baseYear = era.year
        var eraName = era.name

        if (year > baseYear) {
            var eraYear = year - baseYear

            if (eraYear === 1) {
                return eraName + '元年'
            }

            return eraName + eraYear + '年'
        }
    }

    return null
}

export default wareki
